import dayjs from "dayjs";

export const coRecvColumns=[
    {
      field: "lineNo",
      headerName: "Line No",
      align: "right",
    },
    {
      field: "skuCode",
      headerName: "SKU Code",
      align: "left",
      left:180,
      width:200
    },
    {
      field: "packType",
      headerName: "Pack Type",
      width: 120,
      align: "left",
    },
    {
      field: "baseUOM",
      headerName: "Base UOM",
      width: 120,
      align: "left",
    },
    {
      field: "cartonID",
      headerName: "Carton ID",
      width: 150,
      align: "left",
    },
    {
      field: "vDONo",
      headerName: "Do No",
      width: 150,
      align: "left",
    },
    {
      field: "vInvNo",
      headerName: "Inv No",
      width: 150,
      align: "left",
    },
    {
      field: "mln",
      headerName: "MLN",
      width: 150,
      align: "left",
    },
    {
      field: "expiryDate",
      headerName: "Expiry Date",
      width: 120,
      align: "left",
      valuesGetter: (col) => {
        return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
      },
    },
    {
      field: "qtyExpected",
      headerName: "Qty Expected",
      width: 120,
      align: "right",
    },
    {
      field: "qtyReceived",
      headerName: "Qty Received",
      width: 120,
      align: "right",
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      align: "right",
    },
    {
      field: "manufacturingDate",
      headerName: "MFG Date",
      width: 120,
      align: "left",
      valuesGetter: (col) => {
        return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
      },
    },
    {
      field: "recvLocation",
      headerName: "Recv Location",
      width: 150,
      align: "left",
    }
]
export const coRecvViewColumns=[
  {
    field: "lineNo",
    headerName: "Line No",
    align: "right",
    left:0,
    width:100
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    align: "left",
    left:100,
    width:200
  },
  {
    field: "packType",
    headerName: "Pack Type",
    width: 120,
    align: "left",
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    width: 120,
    align: "left",
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    width: 150,
    align: "left",
  },
  {
    field: "vDONo",
    headerName: "Do No",
    width: 150,
    align: "left",
  },
  {
    field: "vInvNo",
    headerName: "Inv No",
    width: 150,
    align: "left",
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 150,
    align: "left",
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 120,
    align: "left",
  },
  {
    field: "qtyExpected",
    headerName: "Qty Expected",
    width: 120,
    align: "right",
  },
  {
    field: "qtyReceived",
    headerName: "Qty Received",
    width: 120,
    align: "right",
  },
  {
    field: "quantity",
    headerName: "Quantity",
    width: 100,
    align: "right",
  },
  {
    field: "manufacturingDate",
    headerName: "MFG Date",
    width: 120,
    align: "left",
  },
  {
    field: "recvLocation",
    headerName: "Recv Location",
    width: 150,
    align: "left",
  }
]